import { Action, createReducer, on } from '@ngrx/store';
import * as catalogActions from './actions';
import { CatalogState } from './state';

export const initialStateCatalog = {};

const catalogReducers = createReducer(
  initialStateCatalog,
  on(catalogActions.LoadCatalogSuccess, (state, { catalog }) => ({ ...state, ...catalog })),
)

export function reducers(state: CatalogState | undefined, action: Action): {} {
  return catalogReducers(state, action)
}
